import { useEffect } from 'react';

/**
 * 키오스크 네비게이션 방지
 * - beforeunload: 새로고침/탭닫기 방지
 * - popstate + pushState: 뒤로가기 방지
 * - keydown: F5, Ctrl+R 차단
 */
export function usePreventNavigation(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;

    // 새로고침/탭닫기 방지
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    // 뒤로가기 방지: history에 더미 항목 추가
    const handlePopState = () => {
      window.history.pushState(null, '', window.location.href);
    };

    // F5, Ctrl+R 키보드 차단
    const handleKeyDown = (e: KeyboardEvent) => {
      // F5
      if (e.key === 'F5') {
        e.preventDefault();
        return;
      }
      // Ctrl+R (Windows/Linux) 또는 Cmd+R (Mac)
      if ((e.ctrlKey || e.metaKey) && e.key === 'r') {
        e.preventDefault();
        return;
      }
      // Ctrl+Shift+R
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'R') {
        e.preventDefault();
        return;
      }
    };

    // 초기 history 상태 설정
    window.history.pushState(null, '', window.location.href);

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled]);
}
